import { PLP_HITS_PER_PAGE } from '~/lib/shopify/constants'
import { getStorePublicCredentials } from '~/lib/shopify/public-client'

import { GID, sfCollection } from '@unlikelystudio/commerce-connector'

import {
  getCountryCode,
  getShopifyLanguageCodeFromLocale,
} from '~/utils/locales'
import { isGID } from '~/utils/shopify-ids'

type TsfCollection = { id?: GID; handle?: string; locale?: string } & Omit<
  Parameters<typeof sfCollection>[1],
  'handle'
>

export async function getSfCollection({
  id,
  locale,
  variantsFirst = 20,
  includePrices = true,
  ...rest
}: TsfCollection) {
  const formatIdIsValid = isGID('Collection', id)

  if (formatIdIsValid) {
    const credentials = getStorePublicCredentials()
    const lang = getShopifyLanguageCodeFromLocale(locale)
    const country = getCountryCode(locale)

    const shopifyCollection = await sfCollection(
      {
        storeUrl: credentials?.storeUrl,
        storefrontAccessToken: credentials?.storefrontAccessToken,
      },
      {
        ...(id && { id }),
        productsFirst: rest?.productsFirst ?? PLP_HITS_PER_PAGE,
        metafieldKeys: rest?.metafieldKeys ?? [],
        productMediaFirst: 10,
        variantsFirst,
        includePrices,
        language: lang,
        country,
        ...rest,
      },
    )

    return shopifyCollection
  } else {
    return null
  }
}
